import { render, staticRenderFns } from "./HighscoreComponent.vue?vue&type=template&id=788a18d9&"
import script from "./HighscoreComponent.vue?vue&type=script&lang=ts&"
export * from "./HighscoreComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports